import { render, staticRenderFns } from "./GroupedItem.vue?vue&type=template&id=9f90a64c&scoped=true&"
import script from "./GroupedItem.vue?vue&type=script&lang=js&"
export * from "./GroupedItem.vue?vue&type=script&lang=js&"
import style0 from "./GroupedItem.vue?vue&type=style&index=0&id=9f90a64c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f90a64c",
  null
  
)

export default component.exports